// FONT-2026-10-02 - V3-only CLONE of pdfConfig.js, used ONLY by OrderPDFV3/
// DownloadOrderPDFV3 (SalesOrderV3.js's own Sales Order print). The original
// pdfConfig.js is shared through OrderPDF by ~27 pages including frozen v1/v2
// ones, so it stays untouched. Differences: table body fonts 8px -> 10.7px
// (+2pt, the client's ask) and a re-balanced column set (the ...V3 styles at the
// bottom) so the bigger font does not overflow. To revert: point SalesOrderV3.js
// back at OrderPDF/DownloadOrderPDF and delete this file + the two V3 components.
import { StyleSheet } from '@react-pdf/renderer'

const pdfConfig = StyleSheet.create({
HeaderStyle: {
        backgroundColor: "rgb(255, 255, 255)",
        color: "rgb(0, 0, 0)",
    },
    HeaderMargin: {
        top: "30px",
        height: "110px"
    },
    BusinessLogo: {
        width: "150px",
        left: "35px",
        top: "10px",

    },
    ContactInfo: {
        textAlign: "justify",
        fontSize: "12px",
        top: "-30px",
        left: "220px"
    },
    marginInfo: {
        width: "80%",
        marginLeft: "12%",
        display: "flex",
        flexDirection: "row",
        marginBottom: "2px",
        color: "rgb(255, 255, 255)"

    },
    OrderTitleStyle: {
        color: "rgb(0, 0, 0)",
        textAlign: "center",
        fontSize: "20px",
        marginTop: "0px",
        marginBottom: "15px"
    },
    OrderInformation: {
        width: "100%",
        backgroundColor: "rgb(255, 255, 255)",
    },
    TitleStyle: {
        textAlign: "left",
        fontSize: "10px",
        width: "50%",
        color: "rgb(0, 0, 0)",
    },

    TextSeparator: {
        marginBottom: "4px"
    },
    InfoEncabezadoStyle: {
        width: "30%",
        fontSize: "12px",
    },
    TextSeparator2: {
        marginTop: "1px",
        marginBottom: "3.5px"
    },

    Table: {
        width: "92%",
        marginLeft: "4%",
        marginTop: "9px"

    },

    CabeceraTabla: {
        width: "100%",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "center",
        display: "flex",
        flexDirection: "row",
        borderBottom: '1px',
        borderColor: 'black',
        borderStyle: 'dotted',
    },
    CuerpoTabla: {
        width: "100%",
        textAlign: "center",
        fontSize: "10.7px",
        borderBottom: '1px',
        borderColor: 'black',
        borderStyle: 'dotted',

    },
    Fila: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
    },
    FilaBreak: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        paddingTop: "2px"
    },
    ColumnaPie: {

        textAlign: "center",
        fontSize: "10px",
    },
    ColumnaTextoNormal: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo: {
        width: "25%",

        fontSize: "8px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargoCenter: {
        width: "20%",
        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },
    ColumnaCantidades: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },

    ColumnaTextoNormalTitulo: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block"
    },
    ColumnaTextoLargoTitulo: {
        width: "25%",

        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo4Titulo: {
        width: "70%",

        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargoCenterTitulo: {
        width: "20%",

        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },

    ColumnaCantidadesTitulo: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo2: {
        width: "35%",
        fontSize: "10.7px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargo2Titulo: {
        width: "35%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo3: {
        width: "50%",
        fontSize: "8px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargo4: {
        width: "70%",
        fontSize: "8px",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoLargo3Titulo: {
        width: "50%",
        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormal2: {
        fontSize: "8px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormal2Titulo: {
        fontSize: "8px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },

    CommentStyle: {
        marginTop: '15px',
        fontSize: "10.7px",
        width: "100%",
        backgroundColor: "#FFFFFF",
        color: "#000000",
        textAlign: "justify",
        borderBottom: '1px',
        borderRight: '1px',
        borderLeft: '1px',
        borderTop: '1px',
        borderColor: 'black',
        borderStyle: 'solid',
    },
    ColumnaHeader: {
        width: "35%",
        fontSize: "11px",
        textAlign: "left",
        display: "block",
        color: "#000000"
    },
    ColumnaHeader2: {
        width: "15%",
        fontSize: "11px",
        textAlign: "left",
        display: "block",
        color: "#000000",

    },
    ColumnaTextoNormalLeft: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "left",
        display: "block",

    },
    ColumnaPrecios: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    ColumnaPreciosTitulo: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormalLeftTitulo: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormalBottom: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargoBottom: {
        width: "25%",

        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargoCenterBottom: {
        width: "20%",
        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },

    ColumnaCantidadesBottom: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo2Bottom: {
        width: "35%",
        fontSize: "10.7px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo3Bottom: {
        width: "50%",
        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoLargo4Bottom: {
        width: "70%",
        fontSize: "8px",
        textAlign: "center",
        display: "block",

    },
    ColumnaTextoNormal2Bottom: {
        fontSize: "8px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },
    ColumnaPreciosBottom: {
        width: "8%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    ColumnaTextoNormalLeftBottom: {
        fontSize: "10.7px",
        width: "12.5%",
        textAlign: "center",
        display: "block",

    },

    ColumnaTextoNormal2Left: {
        fontSize: "8px",
        width: "25%",
        textAlign: "left",
        display: "block",

    },
    ColumnaTextoNormal2LeftTitulo: {
        fontSize: "8px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },

    ColumnaTextoNormal2LeftBottom: {
        fontSize: "8px",
        width: "25%",
        textAlign: "center",
        display: "block",

    },
    DolarTitulo: {
        width: "2.5%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    Dolar: {
        width: "2.5%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    },
    DolarBottom: {
        width: "2.5%",
        fontSize: "10.7px",
        textAlign: "right",
        display: "block",

    }
    ,
    // --- V3-only column styles (FONT-2026-10-02) - widths re-balanced for the bigger body font:
    // the original layout wasted two 12.5-percent columns on empty spacers while the description
    // only got 35 percent. Same Titulo/Bottom suffix convention the component expects.
    ColumnaCodeV3: { fontSize: "10.7px", width: "17%", textAlign: "left", display: "block" },
    ColumnaCodeV3Titulo: { fontSize: "10.7px", width: "17%", textAlign: "center", display: "block" },
    ColumnaCodeV3Bottom: { fontSize: "10.7px", width: "17%", textAlign: "center", display: "block" },
    ColumnaSpacerV3: { fontSize: "10.7px", width: "1%", textAlign: "left", display: "block" },
    ColumnaSpacerV3Titulo: { fontSize: "10.7px", width: "1%", textAlign: "center", display: "block" },
    ColumnaSpacerV3Bottom: { fontSize: "10.7px", width: "1%", textAlign: "center", display: "block" },
    ColumnaDescV3: { fontSize: "10.7px", width: "45%", textAlign: "left", display: "block" },
    ColumnaDescV3Titulo: { fontSize: "10.7px", width: "45%", textAlign: "center", display: "block" },
    ColumnaDescV3Bottom: { fontSize: "10.7px", width: "45%", textAlign: "right", display: "block" },
    ColumnaQtyV3: { fontSize: "10.7px", width: "9%", textAlign: "center", display: "block" },
    ColumnaQtyV3Titulo: { fontSize: "10.7px", width: "9%", textAlign: "center", display: "block" },
    ColumnaQtyV3Bottom: { fontSize: "10.7px", width: "9%", textAlign: "center", display: "block" },
    ColumnaDolarV3: { fontSize: "10.7px", width: "3%", textAlign: "right", display: "block" },
    ColumnaDolarV3Titulo: { fontSize: "10.7px", width: "3%", textAlign: "right", display: "block" },
    ColumnaDolarV3Bottom: { fontSize: "10.7px", width: "3%", textAlign: "right", display: "block" },
    ColumnaPriceV3: { fontSize: "10.7px", width: "10.5%", textAlign: "right", display: "block" },
    ColumnaPriceV3Titulo: { fontSize: "10.7px", width: "10.5%", textAlign: "center", display: "block" },
    ColumnaPriceV3Bottom: { fontSize: "10.7px", width: "10.5%", textAlign: "right", display: "block" }
    ,
    // --- TOTAL-2026-10-05 (client's ask: big, bold TOTAL like the Invoice/Packing List PDF) ---
    // Used ONLY by the totals row, through the optional `bottomStyleColumns` prop of
    // OrderPDFV3 / DownloadOrderPDFV3 (no prop = the old Bottom styles above, unchanged).
    // Widths keep the same total as the body columns (17+1+45+1+9+3+10.5+3+10.5 = 100) so the
    // quantity total still sits under the Quantity column; the empty Price cell gives 4 points of
    // width to the amount so a 14px bold figure fits on one line.
    ColumnaDescTotV3Bottom: { fontSize: "14px", fontFamily: "Helvetica-Bold", width: "45%", textAlign: "right", display: "block" },
    ColumnaQtyTotV3Bottom: { fontSize: "14px", fontFamily: "Helvetica-Bold", width: "9%", textAlign: "center", display: "block" },
    ColumnaPriceBlankV3Bottom: { fontSize: "10.7px", width: "6.5%", textAlign: "right", display: "block" },
    ColumnaDolarTotV3Bottom: { fontSize: "14px", fontFamily: "Helvetica-Bold", width: "3%", textAlign: "right", display: "block" },
    ColumnaPriceTotV3Bottom: { fontSize: "14px", fontFamily: "Helvetica-Bold", width: "14.5%", textAlign: "right", display: "block" }
});

export default pdfConfig;